import { useEffect } from 'react';

const useScript = url => {
    useEffect(() => {
        const script = document.createElement('script');

        script.src = url;
        script.async=false;
        // script.charset='UTF-8';
        // script.setAttribute('crossorigin','*');
        // script.type="application/javascript";

        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        }
    }, [url]);
};

export default useScript;
